/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React from "react";
import { Draggable } from "react-beautiful-dnd";
import useToggle from "./useToggleState";
import KanbanEditForm from "./KanbanEditForm";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const KanbanTask = (props) => {
    const [isEditing, toggle] = useToggle(false);

    const tooltip = (
        <Tooltip id="tooltip">
            {props.task.type === "ola" && (
                <span>{props.task.phase}<br />
                    {props.task.contactHoursQ1}|{props.task.contactHoursQ2}|{props.task.contactHoursQ3}|{props.task.contactHoursQ4}<br />
                </span>
            )}
            {props.task.vte}%
        </Tooltip>
    );

    return (
        <Draggable draggableId={`${props.task.id}`} index={props.index}>
            {(provided) => (
                <OverlayTrigger placement="left" overlay={tooltip}>
                    <div
                        style={{ backgroundColor: (props.task.color || '#e6e6e6') }}
                        className={props.task.show ? "KanbanTask" : "KanbanTask d-none"}>
                        <div
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}
                        >
                            {isEditing ? (
                                <KanbanEditForm
                                    color={props.color}
                                    editTask={props.editTask}
                                    taskId={props.task.id}
                                    toggle={toggle}
                                    startUser={props.task.user}
                                    startText={props.task.text}
                                />
                            ) : (
                                <>
                                    <div className="KanbanTask-assigned">
                                        <span className="KanbanTask-assigned-img">
                                            {props.task.type === "task" && (
                                                <span>
                                                    <i className="fas fa-thumbtack" />
                                                </span>
                                            )}
                                            {props.task.opoResponsible && (
                                                <span>
                                                    <i className="far fa-award" />&nbsp;
                                                </span>
                                            )}
                                            {props.task.ola}
                                            {props.task.planPerPhase && (
                                                <span> ({props.task.phase})</span>
                                            )}
                                            {props.task.internship && (
                                                <span>({props.task.internshipStudents})</span>
                                            )}
                                            {props.task.percentageOverride > 0 && (
                                                <span className="text-warning">
                                                    &nbsp;<i className="fas fa-bolt" />
                                                </span>
                                            )}
                                            {props.task.comment && (
                                                <span className="text-info">
                                                    &nbsp;<i className="far fa-comment-dots" />
                                                </span>
                                            )}
                                        </span>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </OverlayTrigger>

            )}
        </Draggable>
    );
};

export default KanbanTask;